import React from 'react';
import { Link } from 'react-router-dom';
import { useDoorlyProAuth } from '../../context/DoorlyProAuthContext';
import DoorlyProLayout, { RequirePartnerAuth } from '../../components/DoorlyProLayout';
import BorrowerJourney from '../../components/doorlypro/BorrowerJourney';

// Standalone full-journey reference — BorrowerJourney in REFERENCE mode (no
// currentStatus), so every status is expanded with its definition + next step.
export default function DoorlyProBorrowerJourney() {
  // 🔑 THE TYPE REACHES THE JOURNEY. Its per-status next steps differ by
  // partner type and nothing was selecting the override — see
  // BorrowerJourney's header.
  const { partner } = useDoorlyProAuth();
  return (
    <RequirePartnerAuth>
      <DoorlyProLayout>
        <div style={{ maxWidth: 700 }}>
          <div style={{ marginBottom: 24 }}>
            <Link to="/doorlypro/dashboard" style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none' }}>
              &larr; Back to Dashboard
            </Link>
            <h1 style={{ fontSize: 22, fontWeight: 800, color: '#111827', margin: '8px 0 4px' }}>
              Borrower Journey
            </h1>
            <p style={{ fontSize: 14, color: '#6b7280', margin: 0 }}>
              What each status means and what's next.
            </p>
          </div>

          <BorrowerJourney title={null} partnerType={partner?.partner_type} />
        </div>
      </DoorlyProLayout>
    </RequirePartnerAuth>
  );
}
